const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.room_groups/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.room_groups/LIST_ROOM_GROUPS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
